import React from 'react';
import { Avatar as MuiAvatar, IconButton } from '@mui/material';
import getInitials from '../../../../lib/helpers/getInitials';
import useMenu from '../../../../hooks/useMenu';
import { CustomListItemList } from '../../CustomListItemList/CustomListItemList';
import CustomMenu from '../../../../mui/CustomMenu/CustomMenu';
import useProfileLinks from '../../../../config/useProfileLinks';
import { useSelector } from 'react-redux';
import { FlattenedUser } from '../../../../types/user';
import { UserType } from '#types';

/**
 * This avatar component is used to display the user's avatar and menu in the top navigation bar.
 */
export const Avatar: React.FC = () => {
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );
	const orgUser =
		user?.isLoggedIn && user.userType === UserType.OrgUser ? user : undefined;
	const clientUser =
		user?.isLoggedIn && user.userType === UserType.ClientUser
			? user
			: undefined;
	const menu = useMenu();
	const items = useProfileLinks();

	const image = orgUser ? orgUser.organization.image : undefined;
	const updatedAt = orgUser?.organization?.updatedAt;
	// Add updatedAt to image URL for cache-busting
	const imageUrl =
		image && updatedAt ? `${ image }?updatedAt=${ updatedAt }` : image;

	const name = user?.isLoggedIn
		? user.userType === UserType.OrgUser
			? orgUser?.organization?.name
			: user.userType === UserType.ClientUser
				? `${ clientUser?.firstNameOne } ${ clientUser?.lastNameOne }`
				: 'Super Admin'
		: undefined;

	if ( !name ) {
		return null;
	}

	return (
		<>
			<IconButton
				onClick={ menu.handleClick }
				data-cy={ 'profileBtn' }
				size='small'
				aria-controls={ menu.open ? 'account-menu' : undefined }
				aria-haspopup='true'
				aria-expanded={ menu.open ? 'true' : undefined }
			>
				<MuiAvatar src={ imageUrl || undefined }>
					{ getInitials( { name } ) }
				</MuiAvatar>
			</IconButton>

			<CustomMenu
				data-cy='profileMenu'
				anchorEl={ menu.anchorEl }
				open={ menu.open }
				onClose={ menu.handleClose }
				onClick={ menu.handleClose }
				slotProps={ {
					paper: {
						elevation: 0,
					},
				} }
			>
				<CustomListItemList items={ items } />
			</CustomMenu>
		</>
	);
};
